import { useState } from 'react';
import { calendrierAssurance } from '../domaine/rappelAssurance';
import { telecharger } from '../domaine/telechargement';

export function RappelAssurance() {
  const [echeance, setEcheance] = useState('');
  const [jours, setJours] = useState(30);
  const [erreur, setErreur] = useState('');
  const [prepare, setPrepare] = useState(false);
  return <section className="panneau" aria-labelledby="rappel-assurance">
    <h2 id="rappel-assurance">Rappel du renouvellement d’assurance</h2>
    <p>Saisissez l’échéance de votre entreprise et importez le fichier téléchargé dans votre calendrier pour recevoir
      le rappel. Cette date reste dans ce formulaire ; le calendrier conserve le rappel après import.</p>
    <form className="pile" onSubmit={(e) => {
      e.preventDefault();
      try {
        telecharger(new Blob([calendrierAssurance(echeance, jours)], { type: 'text/calendar;charset=utf-8' }),
          'rappel-renouvellement-assurance.ics');
        setErreur(''); setPrepare(true);
      } catch { setErreur('Saisissez une date valide.'); }
    }}>
      <label>Échéance <input type="date" required value={echeance} onChange={(e) => {
        setEcheance(e.target.value); setPrepare(false);
      }} /></label>
      <label>Rappel avant l’échéance <select value={jours} onChange={(e) => {
        setJours(Number(e.target.value)); setPrepare(false);
      }}>
        <option value={30}>30 jours</option><option value={60}>60 jours</option><option value={7}>7 jours</option>
      </select></label>
      <button type="submit">Télécharger le rappel calendrier</button>
      {erreur && <p role="alert">{erreur}</p>}
      {prepare && <p role="status">Fichier préparé. Importez-le dans votre calendrier et vérifiez que l’alarme est activée.</p>}
    </form>
    <p>Les dossiers d’assurance et la synthèse pour le financeur se relisent et se valident ici, puis se téléchargent
      en Word ou en PDF. L’entreprise les transmet elle-même ; Ekera n’envoie rien à un assureur ni à une banque.</p>
  </section>;
}
